import { render, staticRenderFns } from "./DoctorReport.vue?vue&type=template&id=70874456"
import script from "./DoctorReport.vue?vue&type=script&lang=js"
export * from "./DoctorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports